<a (click)="downloadFile()"><span class="k-icon k-font-icon k-i-download"></span> Click to Download</a>